import { Table } from "antd";
import { useState, useEffect, useRef, useContext } from "react";
const { Column } = Table;
import { sprintf } from "sprintf-js";
import { EditableContext } from "../../common/EditableContextProvider";

const TableComponent = () => {
    const { items, loading, tableParams, handleTableChange} = useContext(EditableContext);
    const searchInput = useRef(null);

    const ActionButtons = ({ item }) => {
        return (
            <>
                <button className="btn btn-sm btn-action btn-light border py-0" title="Editar"
                    onClick={() => items.selectItem(item)}>
                    <span className="fas fa-pen text-sm" style={{ fontSize: '0.85em' }}></span>
                </button>
                <button className="btn btn-sm btn-action btn-light border py-0 ms-1" title="Eliminar"
                    onClick={() => items.handle_delete(item.id)}>
                    <span className="fas fa-trash text-sm" style={{ fontSize: '0.85em' }}></span>
                </button>
            </>
        );
    }

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div className="p-1" onKeyDown={e => e.stopPropagation()}>
                <input type="text" className="form-control form-control-sm"
                    ref={searchInput}
                    placeholder='Escribe algo...'
                    value={(selectedKeys[0]) ? selectedKeys[0] : ""}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onKeyUp={(e) => {
                        if (e.key === 'Enter') { handleSearch(selectedKeys, confirm, dataIndex) }
                    }}
                />
                <div className="mt-1 d-flex justify-content-center">
                    <button className="btn btn-sm btn-light border mx-1"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    >
                        <span className="fas fa-search"></span>
                    </button>

                    <button className="btn btn-sm btn-light border mx-1"
                        onClick={() => clearFilters && handleReset(clearFilters, setSelectedKeys, confirm)}
                    >
                        Reset
                    </button>

                    <button className="btn btn-sm btn-light border mx-1"
                        onClick={() => { close(); }}
                    >
                        Salir
                    </button>
                </div>
            </div>
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) { setTimeout(() => searchInput.current?.select(), 100); }
        }
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
    };
    const handleReset = (clearFilters, setSelectedKeys, confirm) => {
        clearFilters();
        setSelectedKeys([]);
        confirm();
    };

    return (
        <Table
            size="small"
            dataSource={items.items}
            rowKey='id'
            loading={loading}
            onChange={handleTableChange}
            pagination={{ ...tableParams?.pagination, position: ['bottomCenter'], showSizeChanger: true }}
            scroll={{ y: 400, }}
            bordered
        >
            <Column title="*" dataIndex="id" key="buttons" width={90} className="text-center"
                render={(id, row) => (<ActionButtons item={row} />)}
            />
            <Column title="ID" dataIndex="id" key="id" align="center" className="fw-bold"
                sorter={true}
                width={100}
                render={(value) => sprintf('%04d', value)}
            />
            <Column title="Código Cliente" dataIndex="codigo" key="codigo"
                sorter={true}
                width={100}
                filterDropdown={getColumnSearchProps('codigo').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('codigo').onFilterDropdownOpenChange}
            />
            <Column title="Nombres" dataIndex="nombres" key="nombres"
                sorter={true}
                width={200}
                filterDropdown={getColumnSearchProps('nombres').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('nombres').onFilterDropdownOpenChange}
            />
            <Column title="Apellidos" dataIndex="apellidos" key="apellidos"
                sorter={true}
                width={200}
                filterDropdown={getColumnSearchProps('apellidos').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('apellidos').onFilterDropdownOpenChange}
            />
            <Column title="Celular" dataIndex="celular" key="celular"
                sorter={true}
                width={200}
                filterDropdown={getColumnSearchProps('celular').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('celular').onFilterDropdownOpenChange}
            />
            <Column title="Dirección" dataIndex="direccion" key="direccion"
                width={200}
                sorter={true}
                filterDropdown={getColumnSearchProps('direccion').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('direccion').onFilterDropdownOpenChange}
            />
        </Table>
    );
}

export default TableComponent;
